import { render } from "./CollectionBrowser.vue?vue&type=template&id=1003ec81"
import script from "./CollectionBrowser.vue?vue&type=script&lang=js"
export * from "./CollectionBrowser.vue?vue&type=script&lang=js"

import "./CollectionBrowser.vue?vue&type=style&index=0&id=1003ec81&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__